export enum KindEnum {
  cashIn = "cashIn",
  cashOut = "cashOut",
}
